export enum EmployeesEndpoints {
  GetBranchEmployeesOrder = 'GetBranchEmployeesOrder',
  SetBranchEmployeesOrder = 'SetBranchEmployeesOrder',
  SetWorkState = 'SetWorkState',
}

export interface ModelEmployeeOrder {
  EmployeeId: number;
  Employee: string | null;
  PositionId: number | null;
  Position: string | null;
  OrderIndex: number;
}

export interface ModelBranchEmployeesOrder {
  BranchId: number;
  Branch: string | null;
  Employees: ModelEmployeeOrder[] | null;
}

export interface ModelOrderIndex {
  ObjectId: number;
  OrderIndex: number;
}

export interface ModelWorkState {
  EmployeeId: number;
  IsWorking: boolean;
}

export interface GetBranchEmployeesOrderRequest {
  ActiveBranchId?: number;
}

export interface SetBranchEmployeesOrderRequest {
  ActiveBranchId?: number;
  data: ModelOrderIndex[];
}

export interface SetWorkStateRequest {
  ActiveBranchId?: number;
  data: ModelWorkState;
}

export type GetBranchEmployeesOrderResponse = ModelBranchEmployeesOrder;
export type SetBranchEmployeesOrderResponse = void;
export type SetWorkStateResponse = void;
